import { render } from "./ErrorPopup.vue?vue&type=template&id=1f72636a"
import script from "./ErrorPopup.vue?vue&type=script&lang=js"
export * from "./ErrorPopup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__